var map = {
	"./1-mobile.png": 784,
	"./1.png": 785,
	"./2-mobile.png": 786,
	"./2.png": 787,
	"./3-mobile.png": 788,
	"./3.png": 789,
	"./4-mobile.png": 790,
	"./4.png": 791,
	"./6-mobile.png": 792,
	"./6.png": 793,
	"./7-mobile.png": 794,
	"./7.png": 795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;